import { onDocumentReady } from 'scripts/util/events'

onDocumentReady(() => {
  const sliders = document.querySelectorAll('.dhsv-video-slider')
  if (sliders.length > 0) {
    import(
      /* webpackChunkName: "dhsv-slider" */
      './init'
    ).then(({ default: init }) => {
      init(sliders)
    })
  }
})
